import React from 'react'
import { Helmet } from "react-helmet";
import Header from '../../components/About/Header'
import FAQSection from '../../components/About/FAQSection'
import Team from '../../components/About/Team'


const About = () => {
  return (
    <>
      <Helmet>
  <title>About Aptech Lekki | Top IT Training School in Nigeria</title>

  {/* Google Analytics */}
  <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16818142902"></script>
  <script>
    {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-16818142902');
    `}
  </script>

  {/* Meta Tags */}
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <meta
    name="description"
    content="Aptech Lekki offers globally recognized IT training in software development, data analytics, design, and more. Build your tech career with us today."
  />
  <meta
    name="keywords"
    content="Aptech Lekki, IT training in Nigeria, software development, data analytics, web development, coding school Lekki, tech school Nigeria"
  />
  <meta property="og:title" content="Aptech Lekki | Trusted IT Training in Nigeria" />
  <meta property="og:url" content="https://aptechlekki.com/" />
  <meta
    property="og:description"
    content="Aptech Lekki offers globally recognized IT training in software development, data analytics, design, and more. Build your tech career with us today."
  />
  <meta name="robots" content="index, follow" />

  {/* Structured Data */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        "name": "Aptech Lekki Centre",
        "url": "https://aptechlekki.com/",
        "logo": "https://aptechlekki.com/logo.png",
        "description": "Aptech Lekki offers IT training in software engineering, mobile development, data analytics, and computer fundamentals in Lekki, Nigeria.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Your Street Address Here",
          "addressLocality": "Lekki",
          "addressRegion": "Lagos",
          "postalCode": "101245",
          "addressCountry": "NG"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+2348134370701",
          "contactType": "Customer Support"
        }
      }
    `}
  </script>
</Helmet>

      <Header />
      <FAQSection />
      <Team />
    </>
  )
}

export default About